import ApplicationLinks from '../../../ApplicationLinks'

export const ADMIN_PANEL_PATH = 'itisadminpanel'

export const ADMIN_ROUTES = {
  home: ApplicationLinks.adminPanelLink(),
  softwareInvoices: ApplicationLinks.adminSoftwareInvoicesLink(),
  searchStores: ApplicationLinks.adminSearchStoresLink(),
  referenceStores: ApplicationLinks.adminReferenceStoresLink(),
  recentlySignedupStores: ApplicationLinks.adminRecentlySignedupStoresLink(),
  subscriptionReport: ApplicationLinks.adminSubscriptionReportLink(),
  expiringSubscriptions: ApplicationLinks.adminExpiringSubscriptionsLink(),
  storePaymentSummary: ApplicationLinks.paymentSummary(),
} as const
